export default __webpack_public_path__ + "static/media/h-bg-apps.b0da52c3.webp";